export const GET_WORKGROUPS = "GET_WORKGROUPS";
export const START_GETTING_USERS_IN_WORKGROUP = "START_GETTING_USERS_IN_WORKGROUP";
export const STOP_GETTING_USERS_IN_WORKGROUP = "STOP_GETTING_USERS_IN_WORKGROUP";
export const GET_USERS_IN_WORKGROUP = "GET_USERS_IN_WORKGROUP";
